import { render, staticRenderFns } from "./ModalAditarItem.vue?vue&type=template&id=fb18951c&scoped=true"
import script from "./ModalAditarItem.vue?vue&type=script&lang=js"
export * from "./ModalAditarItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAditarItem.vue?vue&type=style&index=0&id=fb18951c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18951c",
  null
  
)

export default component.exports